"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vote = vote;
exports.getUserVote = getUserVote;
exports.getVotingResultFromDynamo = getVotingResultFromDynamo;
exports.getVotingResult = getVotingResult;
const transactions_1 = require("@mysten/sui/transactions");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const votingResultsTable_1 = require("./votingResultsTable");
const decimal_js_1 = require("decimal.js");
async function vote(voteIndex, proposalId) {
    const tx = new transactions_1.Transaction();
    if (voteIndex === undefined) {
        console.error("Vote index is undefined");
        return undefined;
    }
    tx.moveCall({
        target: `${(0, alphafi_sdk_1.getConf)().GOVERNANCE_PACKAGE_ID}::governance::vote`,
        arguments: [tx.object(proposalId), tx.pure.u8(voteIndex), tx.object("0x6")],
    });
    return tx;
}
async function getUserVote(address, proposalId) {
    const suiClient = (0, alphafi_sdk_1.getSuiClient)();
    try {
        const obj = await suiClient.getObject({
            id: proposalId,
            options: {
                showContent: true,
            },
        });
        const proposalObj = obj.data?.content;
        const tableId = proposalObj.fields.votes.fields.id.id;
        const dynamicField = await suiClient.getDynamicFieldObject({
            parentId: tableId,
            name: {
                type: "address",
                value: address,
            },
        });
        if (!dynamicField.data?.content) {
            return undefined; // No vote found
        }
        const voteValue = dynamicField.data.content.fields.value;
        return Number(voteValue);
    }
    catch (error) {
        console.error("Error fetching user vote:", error);
        return undefined;
    }
}
async function getVotingResultFromDynamo(proposalId) {
    const results = await (0, votingResultsTable_1.getProposalResults)(proposalId);
    if (!results) {
        return {};
    }
    const formattedResults = {};
    for (const result of results.results) {
        formattedResults[result.voteChoice] = result.aggregatedVotes;
    }
    return formattedResults;
}
async function getVotingResult(proposalId) {
    try {
        const response = await fetch(`https://api.alphafi.xyz/voting-result?proposalId=${proposalId}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const exchangeRate = await (0, alphafi_sdk_1.getPoolExchangeRate)("ALPHA", false);
        return [
            parseFloat(data[0] ? new decimal_js_1.Decimal(data[0]).mul(exchangeRate).toString() : "0"),
            parseFloat(data[1] ? new decimal_js_1.Decimal(data[1]).mul(exchangeRate).toString() : "0"),
        ];
    }
    catch (error) {
        console.error("Error fetching voting result:", error);
        return undefined;
    }
}
//# sourceMappingURL=governance.js.map